import CommonStyles from 'shared/style/commonPageStyles'
import styled from 'styled-components'

const Style = {
	Wrapper: CommonStyles.PageWrapper,
	AreaDiv: styled.div`
		display: flex;
		flex-direction: column;
		gap: 16px;

		& > h2 {
			${({theme}) => theme.font.small_bold};

			& > span {
				color: ${({theme}) => theme.color.major};
				${({theme}) => theme.font.small_bold};
			}
		}
	`,

	ImgUploadDiv: styled.div`
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		gap: 16px;
	`,
	ImgElement: styled.div`
		width: fit-content;
		position: relative;
		display: flex;
		flex-direction: column;
		align-items: end;
		flex-wrap: wrap;
		gap: 6px;

		& > img {
			width: 160px;
			height: 160px;
			object-fit: cover;
			object-position: center center;
			border-radius: 8px;
			cursor: pointer;
		}

		& > button {
			${({theme}) => theme.font.extra_small};
			display: flex;
			align-items: center;
			padding-top: 2px;
		}
	`,
}

export default Style
